(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deliveryroute"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('jaja-route-map')) return;
  const routeDefinitions = {
    north: ['Drenthe, Groningen and Friesland', ['Drenthe', 'Groningen', 'Fryslân']],
    limburg: ['Limburg', ['Limburg']],
    rotterdam_haag: ['Rotterdam and The Hague', []],
    brabant: ['Brabant', ['Noord-Brabant']],
    central: ['Utrecht, Gelderland and Overijssel', ['Utrecht', 'Gelderland', 'Overijssel']],
    noord_holland: ['Amsterdam and North Holland', ['Noord-Holland']],
    rotterdam_zeeland: ['Rotterdam and Zeeland', ['Zeeland']]
  };
  const schedules = {even: {2:'north',3:'limburg',4:'rotterdam_haag',5:'brabant'}, odd:{2:'central',3:'noord_holland',4:'rotterdam_zeeland',5:'brabant'}};
  const addDays = (date, n) => new Date(date.getTime() + n * 86400000);
  const dateKey = date => date.toISOString().slice(0, 10);
  const parseDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(value + 'T12:00:00Z');
    return Number.isFinite(date.getTime()) && dateKey(date) === value ? date : null;
  };
  const weekNumber = date => {
    const d = new Date(date);
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    return Math.ceil(((d - new Date(Date.UTC(d.getUTCFullYear(),0,1))) / 86400000 + 1) / 7);
  };
  const getToday = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const value = part => parts.find(p => p.type === part).value;
    return parseDate(`${value('year')}-${value('month')}-${value('day')}`);
  };
  class JajaRouteMap extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const configNode = this.querySelector('.jaja-route-config');
      if (!configNode) {
        if (!this.contentObserver) {
          this.contentObserver = new MutationObserver(() => {
            if (this.querySelector('.jaja-route-config')) {
              this.contentObserver.disconnect();
              this.contentObserver = null;
              this.connectedCallback();
            }
          });
          this.contentObserver.observe(this, {childList: true, subtree: true});
        }
        return;
      }
      try {
        this.config = JSON.parse(configNode.textContent);
        if (!this.config.strings || !this.config.centres || !this.config.holidays || !Array.isArray(this.config.overrides)) return;
      } catch {
        const notice = this.querySelector('.regions');
        if (notice) notice.textContent = 'The route map could not load. Please reload the page.';
        return;
      }
      this.initialized = true;
      this.strings = this.config.strings;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.today = getToday();
      const requested = parseDate(new URLSearchParams(location.search).get('bezorgdatum'));
      this.selected = requested && requested.getUTCFullYear() >= 2026 && requested.getUTCFullYear() <= 2027 ? requested : this.today;
      this.month = new Date(Date.UTC(this.selected.getUTCFullYear(),this.selected.getUTCMonth(),1,12));
      this.playing = this.config.autoplay && !this.reduced.matches && !requested;
      this.steps = 0;
      this.lastPoint = null;
      this.lastVisible = false;
      this.overrides = new Map(this.config.overrides.filter(o => o && parseDate(o.date)).map(o => [o.date, o]));
      this.querySelector('.prev').onclick = () => this.changeMonth(-1);
      this.querySelector('.next').onclick = () => this.changeMonth(1);
      this.querySelector('.dates').onclick = event => {
        const button = event.target.closest('button[data-date]');
        if (button) this.selectDate(parseDate(button.dataset.date));
      };
      const todayRoute = this.routeFor(getToday());
      const nowButton = this.querySelector('.route-now');
      this.updateTodayStatus();
      nowButton.onclick = () => {
        this.selectDate(getToday());
        const state = this.routeFor(this.selected);
        const map = this.querySelector('.map-wrap');
        const point = state.route ? this.config.centres[state.route[1][0] || 'Zuid-Holland'] : [126, 260];
        if (point) {
          map.style.transformOrigin = `${point[0] / 330 * 100}% ${point[1] / 370 * 100}%`;
          map.classList.add('route-zoomed');
        }
      };
      this.onVisibility = entries => { this.visible = entries.some(entry => entry.isIntersecting); };
      this.visible = false;
      this.intersection = new IntersectionObserver(this.onVisibility, {threshold:0.2});
      this.intersection.observe(this);
      this.resize = new ResizeObserver(() => this.positionBus(false));
      this.resize.observe(this.querySelector('.map'));
      this.motionChanged = () => { if (this.reduced.matches) { this.playing = false; this.stopWheels(); } };
      this.reduced.addEventListener('change', this.motionChanged);
      this.render();
      this.timer = setInterval(() => {
        this.updateTodayStatus();
        if (!this.playing || !this.visible || document.hidden || this.steps >= 8) return;
        let next = this.selected;
        let found = false;
        for (let i = 0; i < 30; i++) {
          next = addDays(next,1);
          if (next.getUTCFullYear() > 2027) break;
          if (this.routeFor(next).route) { found = true; break; }
        }
        if (!found) { this.playing = false; return; }
        this.steps++;
        this.selected = next;
        this.month = new Date(Date.UTC(next.getUTCFullYear(),next.getUTCMonth(),1,12));
        this.render();
      },4200);
    }
    updateTodayStatus() {
      const today = getToday(), state = this.routeFor(today);
      const weekend = today.getUTCDay() === 0 || today.getUTCDay() === 6;
      const button = this.querySelector('.route-now');
      button.textContent = state.route ? `On the road today · ${state.route[0]}` : weekend ? 'Taking a break · weekend in Breda' : 'Parked in Breda · back on the road later';
      button.classList.toggle('is-on-route', !!state.route);
      button.setAttribute('aria-label', `${button.textContent}. View today’s scheduled route.`);
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.contentObserver = null;
      clearInterval(this.timer);
      clearTimeout(this.wheelTimer);
      this.resize?.disconnect();
      this.intersection?.disconnect();
      this.reduced?.removeEventListener('change', this.motionChanged);
      this.initialized = false;
    }
    format(date) {
      return new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(date);
    }
    cutoff(date) {
      return `${this.strings.cutoff_prefix} ${this.format(addDays(date,-1))} ${this.strings.cutoff_suffix}`;
    }
    routeFor(date) {
      const key = dateKey(date), override = this.overrides.get(key);
      const regularKey = schedules[weekNumber(date) % 2 ? 'odd' : 'even'][date.getUTCDay()];
      if (override) {
        if (override.route === 'closed' || override.route === 'check') return {route:null,label:this.strings[override.route],message:override.message || this.strings.check};
        const id = override.route === 'regular' ? regularKey : override.route;
        if (routeDefinitions[id]) return {route:routeDefinitions[id],id,message:override.message || ''};
      }
      if (date.getUTCFullYear() < 2026 || date.getUTCFullYear() > 2027) return {route:null,label:this.strings.check,message:this.strings.unknown};
      const holiday = this.config.holidays[key];
      if (holiday) return {route:null,label:holiday,message:this.strings.holiday_note};
      return regularKey ? {route:routeDefinitions[regularKey],id:regularKey,message:''} : {route:null,label:this.strings.none,message:this.strings.choose_note};
    }
    selectDate(date) {
      this.querySelector('.map-wrap').classList.remove('route-zoomed');
      if (!date) return;
      this.playing = false;
      this.selected = date;
      this.month = new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),1,12));
      this.render();
    }
    changeMonth(delta) {
      this.querySelector('.map-wrap').classList.remove('route-zoomed');
      const next = new Date(this.month);
      next.setUTCMonth(next.getUTCMonth()+delta);
      if (next.getUTCFullYear() < 2026 || next.getUTCFullYear() > 2027) return;
      this.playing = false;
      this.month = next;
      this.render();
    }
    stopWheels() {
      this.querySelector('.bus')?.classList.remove('is-driving');
      clearTimeout(this.wheelTimer);
    }
    positionBus(animate) {
      const state = this.routeFor(this.selected), bus = this.querySelector('.bus');
      const parked = !state.route;
      const point = parked ? [126, 260] : this.config.centres[state.route[1][0] || 'Zuid-Holland'];
      bus.classList.toggle('is-parked', parked);
      bus.classList.toggle('is-sleeping', parked && (this.selected.getUTCDay() === 0 || this.selected.getUTCDay() === 6));
      if (!point || !point.every(Number.isFinite)) {
        bus.hidden = true; bus.style.display = 'none'; this.stopWheels(); return;
      }
      const changed = animate && this.lastVisible && this.lastPoint && Math.hypot(this.lastPoint[0]-point[0],this.lastPoint[1]-point[1]) > 1 && !this.reduced.matches;
      this.stopWheels();
      bus.hidden = false;bus.style.display = 'block';
      if (changed && !parked) {
        bus.classList.add('is-driving');
        this.wheelTimer = setTimeout(() => this.stopWheels(),1800);
      }
      bus.style.left = `${point[0] / 330 * 100}%`;
      bus.style.top = `${point[1] / 370 * this.querySelector('.map').getBoundingClientRect().height}px`;
      this.lastPoint = point;this.lastVisible = true;
    }
    render() {
      const focusedDate = this.querySelector('.dates')?.contains(document.activeElement) ? document.activeElement.dataset.date : null;
      const month = this.month;
      this.querySelector('.monthname').textContent = new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',month:'long',year:'numeric'}).format(month);
      this.querySelector('.prev').disabled = month.getUTCFullYear() === 2026 && month.getUTCMonth() === 0;
      this.querySelector('.next').disabled = month.getUTCFullYear() === 2027 && month.getUTCMonth() === 11;
      const dates = this.querySelector('.dates'), fragment = document.createDocumentFragment();
      const offset = (month.getUTCDay()+6)%7;
      for (let i=0;i<offset;i++) fragment.append(document.createElement('span'));
      const count = new Date(Date.UTC(month.getUTCFullYear(),month.getUTCMonth()+1,0)).getUTCDate();
      for (let day=1;day<=count;day++) {
        const date = new Date(Date.UTC(month.getUTCFullYear(),month.getUTCMonth(),day,12));
        const key = dateKey(date), state = this.routeFor(date), button = document.createElement('button');
        button.type='button';button.className='date';button.textContent=day;button.dataset.date=key;
        button.classList.toggle('route',!!state.route);
        button.classList.toggle('holiday',!!this.config.holidays[key] || this.overrides.has(key));
        button.setAttribute('aria-label', `${this.format(date)} · ${state.route ? state.route[0] : state.label}`);
        button.setAttribute('aria-pressed',String(key===dateKey(this.selected)));
        if (key===dateKey(this.today)) button.setAttribute('aria-current','date');
        fragment.append(button);
      }
      dates.replaceChildren(fragment);
      if (focusedDate && parseDate(focusedDate)) {
        dates.querySelector(`button[data-date="${focusedDate}"]`)?.focus({preventScroll: true});
      }
      const state = this.routeFor(this.selected), week = weekNumber(this.selected);
      this.querySelector('.tag').textContent = `${this.strings.week} ${week} · ${week%2 ? this.strings.odd : this.strings.even}`;
      this.querySelector('.selected-date').textContent=this.format(this.selected);
      this.querySelector('.regions').textContent=state.route ? state.route[0] : 'Parked in Breda';
      this.querySelector('.deadline').textContent=state.route ? this.cutoff(this.selected)+(state.message ? ' '+state.message : '') : (this.selected.getUTCDay() === 0 || this.selected.getUTCDay() === 6) && !this.config.holidays[dateKey(this.selected)] && !this.overrides.has(dateKey(this.selected)) ? 'Enjoying the weekend. Back on the road later.' : state.message;
      this.querySelectorAll('.province').forEach(path=>path.classList.toggle('active',path.dataset.deliveryExcluded !== 'true' && !!state.route && state.route[1].includes(path.dataset.name)));
      this.querySelector('.map').setAttribute('aria-label', state.route ? state.route[0] : state.label);
      this.positionBus(true);
    }
  }
  customElements.define('jaja-route-map',JajaRouteMap);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
